import { useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useSiteSettings() {
  const { data: settings = {}, isLoading } = useQuery({
    queryKey: ["site-settings"],
    queryFn: async () => {
      const { data } = await supabase.from("settings").select("key, value");
      return Object.fromEntries((data || []).map((row) => [row.key, row.value]));
    },
    staleTime: 1000 * 60 * 5,
  });

  const getSetting = (key: string, defaultValue = "") =>
    settings[key] || defaultValue;

  return { settings, getSetting, isLoading };
}

export function useInvalidateSettings() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["site-settings"] });
}
